export interface CreateQLoopDto {
	dateRequired: Date;
	quantity: number;
	workOrderId: number;
}

export class CreateQLoopDto implements CreateQLoopDto {
	constructor(data?: Partial<CreateQLoopDto>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}